import { Link } from "react-router-dom";
import { MessageCircle, ThumbsUp } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";
import { withLang } from "../lib/langPath";
import { timeAgo } from "./common";

export const CATEGORY_NAMES = {
  "stamina-control": "Stamina & Control", "erection-wellness": "Erection Wellness", "pelvic-health": "Pelvic Health", "libido-energy": "Libido & Energy",
  "performance-anxiety": "Performance Anxiety", relationships: "Relationships", fitness: "Fitness", sleep: "Sleep", nutrition: "Nutrition", general: "General Men's Health",
};

export function QuestionCard({ q }) {
  const { t } = useI18n();
  return (
    <Link to={{ pathname: withLang(`/community/question/${q.slug}`, q.language || "en") }} className="ckb-card block p-5 transition-[transform,box-shadow] duration-200 hover:-translate-y-0.5 hover:shadow-md" data-testid={`question-card-${q.slug}`}>
      <div className="flex flex-wrap items-center gap-2 text-xs text-ckb-muted">
        <span className="font-semibold text-ckb-ink2">{q.anon_label}</span>
        {q.age_range && <span>· Age {q.age_range.replace("-", "–")}</span>}
        <span>· {timeAgo(q.published_at || q.created_at)}</span>
        {q.is_sample && <span className="rounded-full bg-ckb-sand2 px-2 py-0.5 text-[10px] uppercase tracking-wide">Sample</span>}
      </div>
      <h3 className="mt-2 font-display text-base font-semibold leading-snug text-ckb-ink sm:text-lg">{q.title}</h3>
      <p className="mt-1 line-clamp-2 text-sm text-ckb-ink2">{q.body}</p>
      <div className="mt-3 flex flex-wrap items-center gap-3 text-xs text-ckb-muted">
        <span className="ckb-chip">{CATEGORY_NAMES[q.category] || q.category}</span>
        <span className="flex items-center gap-1"><MessageCircle className="h-3.5 w-3.5" aria-hidden /> {q.reply_count} {t("replies")}</span>
        <span className="flex items-center gap-1"><ThumbsUp className="h-3.5 w-3.5" aria-hidden /> {q.helpful_count} {t("helpful")}</span>
      </div>
    </Link>
  );
}
